/**
 * This component sits in the avatar component but is mostly invisible.  It pulls an API every minute that calls the backend
 * for a system down status.  Assuming nothing in SYSTEM_DOWN and SYSTEM_DOWN_MSG, it does nothing.  Once it gets a 
 * system down message, it presents that once to the user.  Example of a proper system down message is:
 * System_will_be_down_at_11:00_PM_PST_for_maintenance
 * 
 * It prevents that message from showing twice by putting a value in a local storage variable.
 * 
 * If the component sees true for SYSTEM_DOWN, a different dialog is shown.  This one informs the user that the system is down
 * and logs them off.
 * 
 */
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import withStyles from '@mui/styles/withStyles';
import AbEnvironment from '../auth/AbEnvironment';

import { Button, Dialog, DialogActions, DialogTitle, DialogContent, DialogContentText, Slide } from '@mui/material';

const abEnvironment = new AbEnvironment();

const styleSheet = theme => ({
    root: {
      flexGrow: 1,
    },
    helpicon: {
      marginTop: 3,
      marginRight: 10,
      width: 30,
      height: 30,
      color: theme.palette.primary.main,
    }
});

//how often to check for system 
const systemCheckTime = 60000;  

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});

class SystemMaintenanceAlert extends Component {

  constructor(props) {
    super(props);
 
    this.timer = null;
    this.auth = this.props.auth;

    this.state = {
      warningMessage: '',
      systemDown: false,
      warningClosed: false
    };  

  }

  componentDidMount() {
    if (this.timer === null) {
      //console.log('starting timer');
      this.timer = setInterval(() => this.checkBackend(), systemCheckTime);
      this.checkBackend();
    }

  }

  componentWillUnmount() {
    //console.log('clearing timer');
    if (this.timer != null) {
      clearInterval(this.timer);
    }
    this.timer = null;
  }

  checkBackend() {
    
    //console.log('System maintenance check');

    const { callPartnerApi } = this.props.auth;

    let aPjwt = abEnvironment.getPjwt();

    let payload = {
      operation: "getSystemStatus",
      params: {
        pJwt: aPjwt
      }
    };

    callPartnerApi('appbind/generic',
                   'POST',
                   payload
    )
    .then(resp => {
      return resp.json();
    })
    .then(response => {

      if (response != null && response.data && !response.err) {
        //console.log(response);
        var downMessage = response.data.downMessage.toString();
        downMessage = downMessage.replace(new RegExp('_', 'g'), ' ');
        this.setState({ warningMessage: downMessage, systemDown: response.data.down });
        return;
      } else {
        this.setState({ warningMessage: '', systemDown: false });
      }

    })
    .catch(error => {
      //console.log('error=' + error);
      this.setState({ warningMessage: '', systemDown: false });
    });
  }

  handleWarningClose = () => {
    //this.props.auth.logout();
    localStorage.setItem("sysmaintdismiss", true);
    this.setState({warningClosed: true});
  }

  handleSystemDownClose = () => {
    this.props.auth.logout();
  }

  render() {
    /*const { isAuthenticated, needAssent } = this.props.auth;
    const { classes } = this.props;*/

    var showSystemMaintenanceWarning = false;
    var showSystemDownDialog = false;
    var sysmaintdismiss = localStorage.getItem('sysmaintdismiss');

    if (this.state.warningMessage && this.state.warningMessage.length > 0) {
      if (!sysmaintdismiss) {
        showSystemMaintenanceWarning = true;
      }
    }

    if (this.state.systemDown === true || this.state.systemDown === "true") {
      showSystemDownDialog = true;
    }

    return (

      <div>
          
          <Dialog
            open={showSystemMaintenanceWarning}
            TransitionComponent={Transition}
            onClose={() => {this.handleWarningClose()}}>
            <DialogTitle id="alert-dialog-title">{"Maintenance alert"}</DialogTitle>
            <DialogContent>
              <DialogContentText id="alert-dialog-description">
                {this.state.warningMessage}
              </DialogContentText>
            </DialogContent>
            <DialogActions>
              <Button onClick={() => {this.handleWarningClose()}} color="primary" autoFocus>
                OK
              </Button>
            </DialogActions>
          </Dialog> 
        
          <Dialog
            open={showSystemDownDialog}
            onClose={() => {this.handleSystemDownClose()}}>
            <DialogTitle id="alert-dialog-title">{"Maintenance alert"}</DialogTitle>
            <DialogContent>
              <DialogContentText id="alert-dialog-description">
                System is down for maintenance.  Please check back later.
              </DialogContentText>
            </DialogContent>
            <DialogActions>
              <Button onClick={() => {this.handleSystemDownClose()}} color="primary" autoFocus>
                OK
              </Button>
            </DialogActions>
          </Dialog>
          
      </div>
      );
  }
}
  
SystemMaintenanceAlert.propTypes = {
  classes: PropTypes.object.isRequired,
};
  
export default withStyles(styleSheet)(SystemMaintenanceAlert);